var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKiwi = function SvgKiwi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kiwi_svg__a)",
    d: "M190.053 165c16.3-24.12 17.823-64.739-19.408-81.509-43.294-19.5-106.991-.5-103.508 52.006 3.783 57.017 87.086 82.51 122.916 29.503"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kiwi_svg__b)",
    d: "M202.808 136.022c-.586-2.941-4.615-1.387-7.839.393 1.846-7.244 3.367-20.4-7.119-27.415-7.375 2.177-9.84 13.067-6.416 25.748-4.142-2.179-9.469-3.769-14.027-1.228-2 8.021 3.785 14.028 8.146 17.137-2.587 1.276-6.491 3.9-7.149 5.882 1.591 3.993 7.3 5.748 10.052 5.281-1.422 2.868.58 6.342 1.62 7.074.961.677 3.536-2.045 4.709-3.534 1.981 2.148 4.264 3.3 5.059 2.689.592-.455 1.531-2.484 1.992-4.268 2.522.959 4.5.151 5.876-2.89 1.755-3.868-.525-9.072-1.753-10.708 3.389-2.509 8.041-8.161 6.849-14.161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kiwi_svg__c)",
    d: "M178.069 148.624c-4.853 11.253 7.959 22.628 15.446 5.971 5.999-13.345-7.6-24.161-15.446-5.971"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kiwi_svg__a",
    x1: 196.844,
    x2: 69.203,
    y1: 137.124,
    y2: 131.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kiwi_svg__b",
    x1: 200.515,
    x2: 127.498,
    y1: 140.14,
    y2: 138.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#288FBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#4AA1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#82BEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CEE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kiwi_svg__c",
    x1: 191.706,
    x2: 164.399,
    y1: 155.008,
    y2: 143.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#1D8ABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#3596C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#49A1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#65AFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#ADD5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#DAECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgKiwi;